export const NOT_FOR = {
  badge: "WHO THIS IS NOT FOR",
  headline: [
    { text: "FractoLabs is Likely " },
    { text: "NOT", tone: "pain" },
    { text: " the " },
    { text: "Right Fit", tone: "gain" },
    { text: " For Your Business If:" },
  ],
  label: "Not recommended",
  items: [
    {
      icon: "inbox",
      lead: "Do NOT deploy this if you handle fewer than 5 inbound leads per month.",
      text: "If your lead volume is near zero, an instant-response algorithm won't yield a measurable ROI.",
    },
    {
      icon: "phone",
      lead: "Do NOT deploy this if your team already replies to 100% of leads in under 60 seconds, 24/7/365.",
      text: "If your response speed is already locked down, you don't need our infrastructure.",
    },
    {
      icon: "door",
      lead: "Do NOT deploy this if your business relies 100% on door-knocking or B2B subcontracting.",
      text: "If you have zero digital inquiries, there is no lead flow to rescue.",
    },
  ],
};
